import { LemonaidViestinTyyppi } from '../../model/lemonaid-viesti'

export class LemonaidViestiUriService {
  annaJulkaistunViestinUri(tyyppi: LemonaidViestinTyyppi): string {
    return 'admin/viestit/' + tyyppi + '/aktiivinen'
  }

  annaViestihistorianCollectionUri(tyyppi: LemonaidViestinTyyppi): string {
    return 'admin/viestit/' + tyyppi + '/aktiivinen/historia'
  }

  annaViestihistorianUri(tyyppi: LemonaidViestinTyyppi, historiaAvain: string): string {
    return 'admin/viestit/' + tyyppi + '/aktiivinen/historia/' + historiaAvain
  }
}
